{
  "title": "Lesser Restoration",
  "source": "Player's Handbook",
  "levelAndSchool": "2nd-level abjuration",
  "level": 2,
  "castingTime": "1 action",
  "range": "Touch",
  "components": "V, S",
  "duration": "Instantaneous",
  "description": [
    "You touch a creature and can end either one disease or one condition afflicting it. The condition can be blinded, deafened, paralyzed, or poisoned."
  ],
  "spellLists": ["artificer", "bard", "cleric", "druid", "paladin", "ranger"]
}
